<template>
  <div class="login_box">
    <div class="login_centent">
      <div class="login_box_title">{{ $t("login.to_login") }}</div>
      <div class="TGA_BOX" v-for="(item, index) in data">
        <div class="TGA_INPUT_BOX" :class="item.active ? 'TGA_BR' : ''">
          <div class="TGA_TEXT">{{ item.name }}</div>
          <input
            autocomplete="new-password"
            v-model="item.input"
            @input="changeCount(item.input, index)"
            class="TGA_INPUT"
            :type="item.type"
          />
          <div class="TGA_INPUT_INIT" v-if="item.active">
            <img src="@/img/mistake.png" alt="" />
            <span>{{ item.Text }}</span>
          </div>
        </div>
      </div>

      <a-button
        class="login_btn"
        type="primary"
        @click="login"
        :disabled="!BTN"
        @keyup.enter="enterSearch"
        :loading="loading"
      >
        {{ $t("login.login") }}
      </a-button>

      <!-- <div
        class="TGA_BTN"
        @click="login"
        :class="BTN ? 'TGA_BTN_ACTIVE' : ''"
        @keyup.enter="enterSearch"
      >
        {{ $t("login.login") }}
      </div> -->
      <div class="router_box">
        <router-link tag="div" class="router_register" :to="{ path: '/type' }">
          {{ $t("login.no_id") }}
          <span>{{ $t("login.to_register") }}</span>
        </router-link>
        <router-link
          tag="div"
          class="router_forget"
          :to="{ path: '/forget' }"
          >{{ $t("login.no_psd") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      data: [
        {
          name: this.$t("login.email"),
          input: "",
          Text: this.$t("login.email_error"),
          active: false,
          type: "email",
        },
        {
          name: this.$t("login.psd"),
          input: "",
          Text: this.$t("login.empty_psd"),
          active: false,
          type: "password",
        },
      ],
      BTN: false,
      loading: false,
    };
  },
  beforeCreate() {},
  created() {
    this.keys();
  },
  methods: {
    ...mapActions("user", ["tipMessage", "Login"]),
    keys() {
      var self = this;
      document.onkeydown = (e) => {
        if (e.keyCode === 13 && self.$route.path == "/login") {
          //回车后执行搜索方法
          this.login();
        }
        return;
      };
    },

    // 点击登录账号
    async login() {
      if (!this.BTN) {
        return;
      }
      var ps =
        /^[\w\!\?\,\<\>\.\@\#\$\%\^\&\*\(\)\{\}\[\]\-\~\+\=\/\\\:\;]{8,15}$/;
      if (!ps.test(this.data[1].input)) {
        this.BTN = false;
        this.data[1].Text = this.$t("login.sum_length");
        this.data[1].active = true;
        return;
      }
      var obj = {
        username: this.data[0].input,
        password: this.$md5(this.data[1].input),
      };

      this.loading = true;

      const res = await this.Login({
        $axios: this.$axios,
        ...obj,
      });

      if (res.code == 200) {
        if (localStorage.getItem("groupType") !== "null") {
          if (
            localStorage.getItem("roleName") &&
            localStorage.getItem("roleName").includes("GAME_DEVELOPER")
          ) {
            this.$router.push({
              path: "/game_management",
            });
          } else {
            this.$router.push({
              path: "/app_management",
            });
          }
        } else {
          this.$router.push({
            path: "/info",
          });
        }
      } else {
        switch (res.code) {
          case -111:
          case -110:
          case -101:
          case -100:
          case -114:
          case -113:
            this.data[0].active = true;
            this.data[0].Text = this.$t(`code[${res.code}]`);
            break;
          case -103:
          case -104:
          case 10014:
            this.data[1].active = true;
            this.data[1].Text = this.$t(`code[${res.code}]`);
            break;
          default:
            this.$message.error(this.$t("code.info"));
        }
      }
      this.loading = false;
    },
    changeCount(text, i) {
      var myReg =
        /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,64}){1,2})$/;
      var ps =
        /^[\w\!\?\,\<\>\.\@\#\$\%\^\&\*\(\)\{\}\[\]\-\~\+\=\/\\\:\;]{8,15}$/;
      if (text == "") {
        this.data[i].active = true;
        if (i == 0) {
          this.data[i].Text = this.$t("login.empty_email");
        } else {
          this.data[i].Text = this.$t("login.empty_psd");
        }
      } else {
        if (i == 0 && !myReg.test(text)) {
          this.data[i].Text = this.$t("login.email_error");
          this.data[i].active = true;
        } else if (i == 1 && !ps.test(text)) {
          console.log("66666");
          this.data[i].Text = this.$t("login.sum_length");
          this.data[i].active = true;
        } else {
          this.BTN = true;
          this.data[i].active = false;
        }
      }
    },

    enterSearch() {
      console.log("kkkkkkk");
    },
  },
  computed: {},
  watch: {
    data: {
      handler: function (newValue, oldValue) {
        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i].input == "") {
            this.BTN = false;
            return;
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped="">
.login_box {
  width: 100%;
  height: 100%;
}
.login_centent {
  margin: 90px auto 0;
  width: 1160px;
  height: 466px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  padding-top: 65px;
}
.login_box_title {
  margin-bottom: 51px;
  color: #282828;
  font-size: 22px;
  text-align: center;
  font-weight: bold;
}

.router_box {
  margin: 20px auto 0;
  width: 325px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.router_register {
  color: #aaaaaa;
  font-size: 14px;
  cursor: pointer;
}
.router_register span {
  color: #4990fa;
}
.router_forget {
  font-size: 14px;
  color: #4990fa;
  cursor: pointer;
}

.login_btn {
  display: block;
  margin: 0 auto;
  width: 325px;
  height: 50px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue